module.exports = __webpack_public_path__ + "static/media/3-1.6f8db0f5.svg";